import { useCallback } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIsJiraUserFirstActiveWithinXDays } from './useIsJiraUserFirstActiveWithinXDays.tsx';
import { useYbrIsNewUserCrossFlow } from './useYbrIsNewUserCrossFlow.tsx';

type UseYbrCrossFlowSuppressionParams = {
	crossFlowProduct?: 'jpd' | 'confluence';
};

export const useYbrCrossFlowSuppression = ({
	crossFlowProduct = 'jpd',
}: UseYbrCrossFlowSuppressionParams = {}): { shouldSuppress: () => boolean } => {
	const [userIsNewUser] = useYbrIsNewUserCrossFlow({ crossFlowProduct });
	const [userIsWithin30Days] = useIsJiraUserFirstActiveWithinXDays(30);

	const shouldSuppress = useCallback(() => {
		if (__SERVER__ || !userIsNewUser) {
			return false;
		}

		if (
			crossFlowProduct === 'jpd' &&
			expVal('jira_ybr_first_batch_cross_flow', 'isYBREnabled', false)
		) {
			return userIsWithin30Days;
		}

		if (
			crossFlowProduct === 'confluence' &&
			expVal('jira_ybr_first_batch_cross_flow_confluence', 'isYBREnabled', false)
		) {
			return userIsWithin30Days;
		}

		return false;
	}, [userIsNewUser, userIsWithin30Days, crossFlowProduct]);

	return {
		shouldSuppress,
	};
};
